import React from "react";

export function TableText(text) {
  return !text ? "-" : <div className="truncate-text-1">{text}</div>;
}
